module.exports = __webpack_public_path__ + "img/dugout-lounge-tables-01.f82b361e.jpeg";